import { Navigate } from "react-router-dom";
import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import { lazy } from "react";
import { Logout } from ".";

const AdminList = Loadable(
  lazy(() => import("../admin-management/admin-list"))
);
const UnauthorizedAccess = Loadable(
  lazy(() => import("../../utils/ui-components/UnauthorizedAccess"))
);

function SuperAdminAuthorizedRoutes(role: any) {
  return [
    {
      path: "/",
      element: <MainLayout role={role} />,
      children: [
        {
          path: "/",
          element: <AdminList />,
        },
        {
          path: "admin",
          children: [
            {
              path: "list",
              element: <AdminList />,
            },
          ],
        },
      ],
    },
    {
      path: "unauthorized",
      element: <UnauthorizedAccess />,
    },
    {
      path: "",
      element: <Navigate to="/admin/list" />,
    },
    {
      path: "dashboard",
      element: <Navigate to="/admin/list" />,
    },
    {
      path: "login",
      element: <Navigate to="/admin/list" />,
    },
    {
      path: "logout",
      element: <Logout />,
    },
    {
      path: "verify-login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "*",
      element: <Navigate to="/unauthorized" />,
    },
  ];
}

export default SuperAdminAuthorizedRoutes;
